import React, { useState } from 'react';
import { BsInfoCircle } from 'react-icons/bs';

const InfoTooltip = ({ text }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <span
            className="info-tooltip-container"
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
        >
            <BsInfoCircle className="info-tooltip-icon" />
            {isVisible && (
                <div className="info-tooltip-content">
                    {text}
                </div>
            )}
        </span>
    );
};

export default InfoTooltip;
